import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RequestParams, ResponseCatalog } from 'Models'
import { StatsTasks, TaskModels, PeriodNameEn, TaskStatus } from 'Modules'
import { Callback } from 'Src/types/utilTypes'

export type TaskState = {
	tasks: ResponseCatalog<TaskModels>
	tasksFromStats: ResponseCatalog<TaskModels>
	viewDetailTask: boolean
	viewDetailTaskFromStats: boolean
	idTask: number | null
	idTaskFromStats: number | null
	stats: StatsTasks
	activeTag: TaskStatus
	activeTagFromStats: TaskStatus
	countAllTasks: number
	countAllTasksFromStats: number
	params: RequestParams
	paramsFromTask: RequestParams
	orderTasks: ResponseCatalog<TaskModels>
	periodStats: StatsTasks
	period: string
	filtersIsVisible: boolean
}

export const TaskInitialState: TaskState = {
	tasks: new ResponseCatalog<TaskModels>(),
	tasksFromStats: new ResponseCatalog<TaskModels>(),
	viewDetailTask: false,
	viewDetailTaskFromStats: false,
	idTask: null,
	idTaskFromStats: null,
	stats: null,
	activeTag: TaskStatus.created,
	activeTagFromStats: TaskStatus.all,
	countAllTasks: null,
	countAllTasksFromStats: null,
	params: new RequestParams(1, 20),
	paramsFromTask: new RequestParams(1, 20),
	orderTasks: new ResponseCatalog<TaskModels>(),
	periodStats: null,
	period: PeriodNameEn.MONTH,
	filtersIsVisible: false,
}

export namespace TasksNC {
	export type GetTasks = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		order_ids?: number[]
		callback?: Callback
	}>
	export type GetTasksFromStats = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetTasks = PayloadAction<ResponseCatalog<TaskModels>>
	export type SetTasksFromStats = PayloadAction<ResponseCatalog<TaskModels>>
	export type setViewDetailTask = PayloadAction<boolean>
	export type setViewDetailTaskFromStats = PayloadAction<boolean>
	export type setIdTask = PayloadAction<number>
	export type setIdTaskFromStats = PayloadAction<number>
	export type setCompletedStatusTask = PayloadAction<{
		id: number
		source: string
	}>
	export type setCreatedStatusTask = PayloadAction<number>
	export type getStatsTasks = PayloadAction<string>
	export type setStatsTasks = PayloadAction<StatsTasks>
	export type setActiveTag = PayloadAction<TaskStatus>
	export type setActiveTagFromStats = PayloadAction<TaskStatus>
	export type setCountAllTasks = PayloadAction<number>
	export type setCountAllTasksFromStats = PayloadAction<number>
	export type setParams = PayloadAction<RequestParams>
	export type setParamsFromStats = PayloadAction<RequestParams>
	export type setOrderTasks = PayloadAction<ResponseCatalog<TaskModels>>
	export type showedTaskTraining = PayloadAction
	export type clickedTaskModelLogo = PayloadAction
	export type getPeriodStats = PayloadAction<string>
	export type setPeriodStats = PayloadAction<StatsTasks>
	export type setPeriod = PayloadAction<string>
	export type SetFiltersIsVisible = PayloadAction<boolean>
}

export const taskSlice = createSlice({
	name: 'task_models',
	initialState: TaskInitialState,
	reducers: {
		getTasks: (state, action: TasksNC.GetTasks) => {},
		getTasksFromStats: (state, action: TasksNC.GetTasksFromStats) => {},
		setTasks: (state, action: TasksNC.SetTasks) => {
			state.tasks = action.payload
		},
		setTasksFromStats: (state, action: TasksNC.SetTasksFromStats) => {
			state.tasksFromStats = action.payload
		},
		setViewDetailTask: (state, action: TasksNC.setViewDetailTask) => {
			state.viewDetailTask = action.payload
		},
		setViewDetailTaskFromStats: (state, action: TasksNC.setViewDetailTaskFromStats) => {
			state.viewDetailTaskFromStats = action.payload
		},
		setIdTask: (state, action: TasksNC.setIdTask) => {
			state.idTask = action.payload
		},
		setIdTaskFromStats: (state, action: TasksNC.setIdTaskFromStats) => {
			state.idTaskFromStats = action.payload
		},
		setCompletedStatusTask: (state, action: TasksNC.setCompletedStatusTask) => {},
		setCreatedStatusTask: (state, action: TasksNC.setCreatedStatusTask) => {},
		getStatsTasks: (state, action: TasksNC.getStatsTasks) => {},
		setStatsTasks: (state, action: TasksNC.setStatsTasks) => {
			state.stats = action.payload
		},
		setActiveTag: (state, action: TasksNC.setActiveTag) => {
			state.activeTag = action.payload
		},
		setActiveTagFromStats: (state, action: TasksNC.setActiveTagFromStats) => {
			state.activeTagFromStats = action.payload
		},
		setCountAllTasks: (state, action: TasksNC.setCountAllTasks) => {
			state.countAllTasks = action.payload
		},
		setCountAllTasksFromStats: (state, action: TasksNC.setCountAllTasksFromStats) => {
			state.countAllTasksFromStats = action.payload
		},
		setParams: (state, action: TasksNC.setParams) => {
			state.params = action.payload
		},
		setParamsFromStats: (state, action: TasksNC.setParamsFromStats) => {
			state.paramsFromTask = action.payload
		},
		setOrderTasks: (state, action: TasksNC.setOrderTasks) => {
			state.orderTasks = action.payload
		},
		showedTaskTraining: (state, action: TasksNC.showedTaskTraining) => {},
		clickedTaskModelLogo: (state, action: TasksNC.clickedTaskModelLogo) => {},
		getPeriodStats: (state, action: TasksNC.getPeriodStats) => {},
		setPeriodStats: (state, action: TasksNC.setPeriodStats) => {
			state.periodStats = action.payload
		},
		setPeriod: (state, action: TasksNC.setPeriod) => {
			state.period = action.payload
		},
		setFiltersIsVisible: (state, action: TasksNC.SetFiltersIsVisible) => {
			state.filtersIsVisible = action.payload
		},
	},
})
